import { Component, Host, h, Element, State, Prop } from '@stencil/core';

export interface A {
  currentIndex: number;
  currentColumns: number;
  rows: HTMLElement[][];
}

@Component({
  tag: 'ui-cms-grid',
  styleUrls: {
    default: 'ui-cms-grid.scss',
    editing: 'ui-cms-grid.magnolia.scss',
  },
  shadow: true,
})
export class UiCmsGrid {
  @Element() el: HTMLElement;

  @Prop() columns = 12;

  @Prop() rowGap = 60;

  @State() rows: HTMLUiCmsGridElementElement[][] = [];

  componentWillLoad() {
    this.el.style.setProperty('--grid-column-width', (1 / this.columns).toString());
    this.el.style.setProperty('--grid-row-gap', this.rowGap.toString());
    this.rows = [].slice.call(this.el.querySelectorAll(':scope > ui-cms-grid-element')).reduce(
      (aggr: A, element: HTMLUiCmsGridElementElement): A => {
        const newColumns = aggr.currentColumns + element.columns;
        const newRow = newColumns > this.columns || (element.centered && aggr.currentIndex !== 0);
        const elementColumns = newRow ? element.columns : newColumns;
        return {
          currentColumns: element.centered ? 12 : elementColumns,
          currentIndex: newRow ? aggr.currentIndex + 1 : aggr.currentIndex,
          rows: newRow
            ? [...aggr.rows, [element]]
            : aggr.rows.map((row, index) => (index === aggr.currentIndex ? [...row, element] : row)),
        };
      },
      {
        currentIndex: 0,
        currentColumns: 0,
        rows: [[]],
      }
    ).rows;

    this.rows.forEach((row, index) => {
      row.forEach((element) => {
        element.setAttribute('slot', index.toString());
        element.style.setProperty('--grid-row-gap-reduction', this.rowGap.toString());
      });
    });
  }

  render() {
    return (
      <Host>
        {this.rows.map((row, index) => [
          <slot name={index.toString()}></slot>,
          row.every((element) => !element.hideSeparator) && index !== this.rows.length - 1 && <hr />,
        ])}
        <slot></slot>
      </Host>
    );
  }
}
